module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Johnette Downing, Deborah Ousley Kadair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Johnette Downing is an award-winning and internationally recognized singer and songwriter. Her many accolades include eight Parents’ Choice Awards, four iParenting Media Awards, and five National Parenting Publication Awards. She wrote and/or illustrated "), _c('B', [_c('I', [_vm._v("There Was an Old Lady Who Swallowed Some Bugs, Why the Crawfish Lives in the Mud, How to Dress a Po’ Boy, Why the Oyster Has the Pearl, Why the Possum Has a Large Grin, Macarooned on a Dessert Island, The Fifolet,")])], 1), _vm._v(" and other Pelican titles. Downing lives in New Orleans, Louisiana.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UyAXk6/tc-custom/9781455619245.jpg?1706327283820",
      "alt": "This image is the cover for the book Today Is Monday in New York, Today Is Monday"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Today Is Monday in New York, Today Is Monday\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“A delightful evocation of some of New York State’s most beloved foods. Guaranteed to make your stomach rumble as you read along.” —Louis Alvarez, independent filmmaker, the Center for New American Media")])]), _c('p', [_vm._v(" On Monday, it’s apples, and Tuesday is pastrami. This catchy walk through a week of yummy New York fare introduces children to the favorite foods of the Empire State. With bright collage illustrations and infectious singsong lyrics, this playful adaptation of a traditional song features such goodies as Buffalo wings, hot dogs, pizza, and cheesecake. A “Word Menu” at the end of the book, along with tips and trivia about the great state of New York, round out this toothsome trip through a week’s worth of tasty eats. Come and eat it up! ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0